import OrderNotifierSFC from "./OrderNotifier.vue";
export const OrderNotifier = OrderNotifierSFC;
